import { useCallback, useId, useMemo, useRef } from 'react';
import groupBy from 'lodash-es/groupBy';
import { createSyntheticEvent, useDeviceType } from '@vfit/shared/hooks';
import { IUseSlotsCalendarInput } from './slotsCalendarInput.models';

export const useSlotsCalendarInput = ({ dateTimes, onChange, ref }: IUseSlotsCalendarInput) => {
  const innerRef = useRef<HTMLInputElement | null>(null);
  const frameDateInputsName = useId();

  const { isMobile, isTablet } = useDeviceType();

  const slots = useMemo(
    () =>
      Object.entries(
        groupBy(
          dateTimes,
          (slot) => new Date(slot?.validFor?.startDateTime).toISOString().split('T')[0]
        )
        // eslint-disable-next-line no-nested-ternary
      ).sort((a, b) => (a[0] < b[0] ? -1 : a[0] > b[0] ? 1 : 0)),
    [dateTimes]
  );

  const onSelect = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      if (e.currentTarget.checked && innerRef.current) {
        const v = e.currentTarget.value;

        // eslint-disable-next-line no-param-reassign
        innerRef.current.value = v;

        const syntheticEvent = createSyntheticEvent(innerRef.current, 'change');

        if (syntheticEvent) {
          onChange?.(syntheticEvent);
        }
      }
    },
    [onChange]
  );

  const refCallback = useCallback(
    (node: HTMLInputElement) => {
      if (node) {
        innerRef.current = node;

        if (ref) {
          if (typeof ref === 'function') {
            ref(node);
          } else {
            // eslint-disable-next-line no-param-reassign
            ref.current = node;
          }
        }
      }
    },
    [ref]
  );

  return { isMobile, isTablet, refCallback, frameDateInputsName, onSelect, slots };
};

